import React, { Component } from 'react';
import Filters from './Filters';
import { GoogleMapsComponentContainer } from './Map';
import { getTranslations } from "./../services/Translates";
import { getTranslateLang } from "../services/Translates";
import { getEndpointData, getRealizations } from './../services/GetDataFromApi';


export default class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowGeo            : null,
            coords              : { latitude: 0, longitude: 0 },
            center              : { latitude: 0, longitude: 0 },
            zoom                : 10,
            load                : null,
            loadingApp          : null,
            country             : '',
            street              : '',
            searchStreet        : '',
            searchedItem        : [],
            countries           : [],
            checkedOptions      : [],
            options             : [],
            realizations        : [],
            realizationsFiltered: [],
            realizationsNear    : [],
            radius              : 10,
            searchCount         : 0,
            seeOnMap            : false,
            iconMap             : '',
            iconType            : '',
            iconCount           : '',
            iconList            : '',
            active              : 999999,
            showFilters         : true,
            m1                  : '',
            m2                  : '',
            m3                  : '',
            m4                  : '',
            m5                  : '',
            aggregate           : '',
            aggregateTemp       : '',
            domainAPI           : '',
        }
    }
    async componentDidMount() {
        await this.getDefaults();
        await getTranslations(this.state.domainAPI);
        await this.getEndpointData('options');
        await this.getEndpointData('countries');
        await this.getEndpointData('realizations');
        await this.setState({ realizations: getRealizations(), realizationsFiltered: getRealizations() })
        await this.getLocation();

    }
    async getDefaults() {
        let This = this;
        let url = `${window.location.protocol}//${window.location.hostname}`;
        if ( window.location.hostname == 'localhost' ) {
            url = 'https://pl.bkfcarwash.info';
        }
        await fetch(`${url}/wp-json/wp/v2/realizations-map/defaults`)
            .then(resp => resp.json())
            .then(resp => {
                This.setState({ 
                    coords   : { latitude: parseFloat(resp.lat), longitude: parseFloat(resp.lng) },
                    center   : { latitude: parseFloat(resp.lat), longitude: parseFloat(resp.lng) },
                    zoom     : parseInt(resp.zoom),
                    radius   : parseInt(resp.radius),
                    iconMap  : resp.image_map.url,
                    iconType : resp.image_type.url,
                    iconCount: resp.image_count.url,
                    iconList : resp.image_list.url,
                    m1       : resp.image_m1.url,
                    m2       : resp.image_m2.url,
                    m3       : resp.image_m3.url,
                    m4       : resp.image_m4.url,
                    m5       : resp.image_m5.url,
                    aggregate: resp.aggregate,
                    aggregateTemp: resp.aggregate,
                    domainAPI: resp.api_link
                });
            })
    }
    getLocation() {
        if (navigator.geolocation ) {
            var coords;
            navigator.geolocation.getCurrentPosition( async (position) => {
                coords = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude  
                }
                await this.setState({ coords: coords });
                await this.setState({ center: coords });
                await this.setState({ allowGeo: coords });
                await this.setState({ load: 1 });
            })
        } 
    }
    getEndpointData(endpoint) {
        let This = this;
        let url = `${window.location.protocol}//${window.location.hostname}`;
        if ( window.location.hostname == 'localhost' ) {
            url = 'https://pl.bkfcarwash.info';
        }
        fetch(`https://${this.state.domainAPI}/wp-json/wp/v2/realizations-map/${ endpoint }`)
            .then(resp => resp.json())
            .then(resp => {
                if ( endpoint == 'realizations')
                    This.setState({ realizationsFiltered: resp });

                This.state[endpoint] = resp;
            })
    }
    async getSearchedPlace(data, setzoom) {
        let This = this;
        
        if (data) {
            await this.setState({
                searchedItem: data,
                zoom: setzoom,
                center: {
                    latitude: data[0].geometry.location.lat(), 
                    longitude: data[0].geometry.location.lng(),
                } 
            });
        }
        
        let filteredItems = this.state.realizations;
        filteredItems = await filteredItems.filter( item => {
            if ( This.state.country  == '') {
                return true;
            } else {
                return item[0].device_country == This.state.country;
            }
        }).filter( item => {
            let searched = item[0].options.length > 0 && item[0].options.map( el => {
                if ( this.state.checkedOptions.includes(el) ) {
                    return true;
                } else {
                    return false;
                }
            })
            let check = (searched ? searched.includes(true) : false);
            
            return (this.state.checkedOptions.length === 0 ? true : check);
        })
        await This.setState({ realizationsFiltered: filteredItems })
        return filteredItems;
    }
    async getNearbyWashes(data) {
        if ( this.state.street != '') {
            await this.setState({ realizationsNear: data });
        } else {
            await this.setState({ realizationsNear: [] });
        }
    }
    async search(){
        let This = this;
        // check width 
        if ( window ) {
            let width = window.innerWidth;
            if ( width < 760 ) {
                let map = document.getElementById('main-map');
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: map.offsetTop
                  });
            }
        }
        await this.setState({ 
            seeOnMap    : false,
            searchStreet: this.state.street,
            searchCount : ++this.state.searchCount,
            aggregate   : "off"
        });
        if(this.state.street != '') {
            await this.setState({ zoom: 16 })
        }
        let filteredItems = this.state.realizations;
        filteredItems = await filteredItems.filter( item => {
            if ( This.state.country  == '') {
                return true;
            } else {
                return item[0].device_country == This.state.country;
            }
        }).filter( item => {
            let searched = item[0].options.length > 0 && item[0].options.map( el => {
                if ( this.state.checkedOptions.includes(el) ) {
                    return true;
                } else {
                    return false;
                }
            })
            let check = (searched ? searched.includes(true) : false);
            
            return (this.state.checkedOptions.length === 0 ? true : check);
        })
        await This.setState({ realizationsFiltered: filteredItems })
        await This.setState({ aggregate           : This.state.aggregateTemp })


    }

    render() {
        
        return (
            <div id="map" className={ ( !this.state.realizations ? 'loading': '') }>
                <div className={" btn-more " + (this.state.showFilters ? 'active' : '') + " show-filters"} onClick={ () => { let prev = this.state.showFilters; this.setState({ showFilters: !prev}) } }> {(this.state.showFilters ? getTranslateLang('ukryj_filtry') : getTranslateLang('pokaz_filtry') )} </div>
                { this.state.showFilters && 
                    <Filters countries={ this.state.countries } 
                    options={ this.state.options } 
                    changeCountry={ async (val) => { 
                        await this.setState({ aggregate: 'off' }); 
                        await this.setState({ country: val });   
                        setTimeout(async () => {
                            await this.setState({ aggregate: this.state.aggregateTemp }); 
                            if ( val == '') {
                                await this.setState({ searchedItem: [] }); 
                                await this.getDefaults();
                            }
                        }, 700);
                    }}
                    changeStreet={ async (val) => {
                        await this.setState({ aggregate: 'off' }); 
                        await this.setState({ street: val })
                        setTimeout(async () => {
                            if ( val == '' && this.state.street == '') {
                                await this.setState({ searchedItem: [] }); 
                                await this.getDefaults();
                            }
                            await this.setState({ aggregate: this.state.aggregateTemp }); 
                        }, 700);
                    } }
                    search={ () => this.search() } 
                    seeOnMap={ (lat, lang, id) => { this.setState({ active: id, zoom: 15, seeOnMap: true, center: { latitude: parseFloat(lat), longitude: parseFloat(lang) }});  }}
                    checkedOptions={ (val) => this.setState({ checkedOptions: val })} 
                    realizationsNear={ this.state.realizationsNear } 
                    radius={ this.state.radius } 
                    setRadius={ (val) => (val ? this.setState({radius: parseInt(val)}) : 10 )  } 
                    iconList={ this.state.iconList }/>
                }
                

                { this.state.realizations && 
                    <GoogleMapsComponentContainer zoom={ this.state.zoom } 
                                         activeTemp={ this.state.active }
                                         changeActiveTemp={ (val) => this.setState({ active: val })}
                                         center={ this.state.center } 
                                         coords={ this.state.coords } 
                                         street={ this.state.street }
                                         options={ this.state.options } 
                                         allowGeo={ this.state.allowGeo } 
                                         getSearchedPlace={ (data, setzoom) => this.getSearchedPlace(data, setzoom) } 
                                         searchedItem={ this.state.searchedItem } 
                                         realizations={ this.state.realizationsFiltered }
                                         search={ this.state.searchCount } 
                                         getNearbyWashes={ (data) => this.getNearbyWashes(data) } 
                                         seeOnMap={ this.state.seeOnMap } 
                                         radius={ this.state.radius }
                                         country={ this.state.country } 
                                         iconCount={ this.state.iconCount }
                                         iconType={ this.state.iconType } 
                                         iconMap={ this.state.iconMap }   
                                         seeOnMap={ (lat, lang) => this.setState({ seeOnMap: true, center: { latitude: parseFloat(lat), longitude: parseFloat(lang) }}) }
                                         m1={ this.state.m1 }
                                         m2={ this.state.m2 }
                                         m3={ this.state.m3 }
                                         m4={ this.state.m4 }
                                         m5={ this.state.m5 }
                                         domain={ this.state.domainAPI }
                                         aggregate={ this.state.aggregate }/>
                }
            </div>
            
        );
    }
    
}

